/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

//
// Azure AD update to add groups to access token:
// https://docs.microsoft.com/en-us/azure/active-directory/hybrid/how-to-connect-fed-group-claims#configure-the-azure-ad-application-registration-for-group-attributes
// Configure the Azure AD Application Registration for group attributes
//
// See below answer for how to do authentivcated routes:
// https://stackoverflow.com/questions/31084779/how-to-restrict-access-to-routes-in-react-router
//

import { LogLevel } from "@azure/msal-browser";


const env = process.env.REACT_APP_ENV;
const envConfig = require(`../../config/config.${env}.json`);


/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signIn:         "B2C_1_SignIn",
        signUpSignIn:   "B2C_1_SignUpSignIn",
        forgotPassword: "B2C_1_ForgotPassword",
    },
    authorities: {
        signIn: {
            authority: "https://northpowermahi.b2clogin.com/northpowermahi.onmicrosoft.com/B2C_1_SignIn",
        },
        signUpSignIn: {
            authority: "https://northpowermahi.b2clogin.com/northpowermahi.onmicrosoft.com/B2C_1_SignUpSignIn",
        },
        forgotPassword: {
            authority: "https://northpowermahi.b2clogin.com/northpowermahi.onmicrosoft.com/B2C_1_ForgotPassword",
        },
    },
    authorityDomain: "northpowermahi.b2clogin.com"
}


/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 *
 * To see how to set up Azue AD:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/quickstart-register-app#register-an-application
 */
export const msalConfig = {
    auth: {
        //
        // See: https://learn.microsoft.com/en-us/azure/active-directory-b2c/configure-authentication-sample-spa-app
        // and: https://learn.microsoft.com/en-us/answers/questions/904183/aadsts50049-invalid-instance-error-for-b2c-login.html
        //
        clientId: envConfig.auth.clientId,
        //
        // authority must match the policy you use to sign in (parameter to loginRedirect)
        // or refresh token calls to B2C get "AADB2C90088: The provided grant has not been issued for this endpoint." errors.
        //
        // authority: b2cPolicies.authorities.signIn.authority,
        authority: b2cPolicies.authorities.signUpSignIn.authority, 
        knownAuthorities: [b2cPolicies.authorityDomain], // B2C only
        redirectUri: envConfig.auth.redirectUri,
        postLogoutRedirectUri: envConfig.auth.postLogoutRedirectUri,
        navigateToLoginRequestUrl: true, // Changed this from false to true to get post-login redirection working.  Was previously set false to get Azure AD B2C working.
    },
    cache: {
        cacheLocation: "localStorage", // Where your tokens will be stored. "sessionStorage" or "localStorage"
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {		
                    case LogLevel.Error:		
                        console.error(message);		
                        return;		
                    case LogLevel.Info:		
                        console.info(message);		
                        return;		
                    case LogLevel.Verbose:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Trace:		
                        console.debug(message);		
                        return;		
                    case LogLevel.Warning:		
                    default:
                        console.warn(message);		
                        return;		
                }	
            },
            // logLevel: LogLevel.Verbose // This is quite verbose
            logLevel: 4
            
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    // Whatever scopes you provide Azure AD B2C does not return name, oid or preferred_username in Id Tokens.
    scopes: ["openid", "email", "profile"]
};
